export default class Constant {
    static get pionexApkHost() {
        return window.origin.replace("download.", "static.")
    }
}
